import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    HostListener,
    Input,
    Output,
    Renderer2,
    SimpleChanges
} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SlideSwitcherComponent),
    multi: true
};

export interface ISlideSwitcherValue {
    value: boolean;
    userChanged: boolean;
}

@Component({
    selector: 'slide-switcher',
    templateUrl: './slide-switcher.component.html',
    styleUrls: ['./slide-switcher.component.less'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR,
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SlideSwitcherComponent),
            multi: true
        }
    ]
})
export class SlideSwitcherComponent implements ControlValueAccessor {

    private _value: boolean = false;

    @Input()
    testId: string = '';

    @Output()
    private switch: EventEmitter<any> = new EventEmitter();

    @Output()
    private change: EventEmitter<any> = new EventEmitter();

    @Input()
    label: string = "";

    @Input()
    labelClass: string = 'b1Color h4Font';

    @Input()
    disabled: boolean = false;

    @Input()
    additionalFunctionForSwitch: Function | undefined;

    hovered: boolean = false;

    switchOptionOffTooltipText = $localize`CLICK_TO_SWITCH_OPTION_OFF`;
    switchOptionOnTooltipText = $localize`CLICK_TO_SWITCH_OPTION_ON`;

    constructor(private element: ElementRef, private renderer: Renderer2) {

    }

    @HostListener('mouseenter')
    public onEnter() {

        this.hovered = true;

    }

    @HostListener('mouseleave')
    public onLeave() {

        this.hovered = false;

    }

    doSwitch(switchValue: boolean, userChanged?: boolean): void {


        this.value = switchValue;

        this.change.emit(this.value);
        this.switch.emit({ value: this.value, userChanged: false });

    }

    onSwitch(): void {
        if (this.disabled) return;

        const callback = () => {
            this.setValueSilent(!this.value);

            this.change.emit(this.value);
            this.switch.emit({ value: this.value, userChanged: true });
        }

        if (this.additionalFunctionForSwitch) {
            this.additionalFunctionForSwitch(this.value, callback);
        } else {
            callback();
        }
    }

    getValue(): boolean  {

        return this.value;

    }

    private setValueSilent(v: boolean): void {
        if (v !== this._value) {
            this._value = v;
            this.onChange(this.value);
        }
    }

    disable(): void {

        this.disabled = true;
        this.renderer.setStyle(this.element.nativeElement, "opacity", "0.3");

    }

    enable(): void {

        this.disabled = false;
        this.renderer.setStyle(this.element.nativeElement, "opacity", "1");

    }

    ngAfterViewInit() {

        this.disabled ? this.disable() : this.enable();

    }

    ngOnChanges(chs: SimpleChanges): void {
        if (chs['disabled']) {
            if (chs['disabled']['currentValue']) {
                this.disable();
                this.switchOptionOffTooltipText = $localize`DISABLE_DRIVERS_TO_CLOSE_TABLE`;
            } else {
                this.enable();
                this.switchOptionOffTooltipText = $localize`CLICK_TO_SWITCH_OPTION_OFF`;
            }
        }
    }

    get value(): any { return this._value; };

    set value(v: any) {

        let val = !!v;

        if (val !== this._value) {


            this._value = val;
            this.doSwitch(val);
            this.onChange(val);


        }

    }

    validate(c: FormControl<boolean>) {
    }

    writeValue(value: any) {

        this.value = <boolean>value;

    }

    onChange = (_: boolean) => { };
    onTouched = () => { };
    registerOnChange(fn: (_: boolean) => void): void { this.onChange = fn; }
    registerOnTouched(fn: () => void): void { this.onTouched = fn; }

}